import { Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const ThankYouDetailModalWrapper = styled.div`
  width: 100%;
  ${Image.S.Image} {
    border: 1px solid var(--color-border-default);
    border-radius: var(--size-border-radius-md);
    display: block;
    margin: 0 auto;
  }
`;

const UserWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const GratitudeBoardCardInfo = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
`;
const GratitudeBoardCardUser = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
`;

export { GratitudeBoardCardInfo, GratitudeBoardCardUser, ThankYouDetailModalWrapper, UserWrapper };
